import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import MaintenanceStairs from "../../components/maintenance-stairs/MaintenanceStairs";

function MaintenanceStairsPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Maintenance Stairs | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Maintenance Stairs"} t={t} />
      <MaintenanceStairs />
    </>
  );
}

export default MaintenanceStairsPage;
